import React from 'react';
import { socialProof } from '../data/content';
export function SocialProof() {
  return <section className="bg-parchment-light text-ink" data-id="element-167" data-mp="3ltdsc5ojntvn">
      <div className="mx-auto max-w-content px-4 py-12 sm:px-6 lg:py-20" data-id="element-168" data-mp="3lu5pvm1pc1ok">
        <h2 className="sr-only" data-id="element-169" data-mp="36wvfkg0sp1uf">{socialProof.title}</h2>
        <img src={socialProof.image} alt={socialProof.imageAlt} loading="lazy" className="mx-auto h-auto w-full max-w-lg mix-blend-multiply" data-id="element-170" data-mp="3buohgwv2f9ow" />
      </div>
    </section>;
}